export const NOTICE_PRIORITIES = ['low', 'medium', 'high', 'very_high'] as const;
export type NoticePriority = (typeof NOTICE_PRIORITIES)[number];

export const NOTICE_PRIORITY_OPTIONS: { value: NoticePriority; label: string }[] = [
  { value: 'low', label: 'Low Priority' },
  { value: 'medium', label: 'Medium Priority' },
  { value: 'high', label: 'High Priority' },
  { value: 'very_high', label: 'Very High Alert' },
];

export const NOTICE_PRIORITY_FILTER_OPTIONS = [
  { value: 'all', label: 'All Priorities' },
  ...NOTICE_PRIORITY_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
];

export const PRIORITY_SORT_ORDER: Record<string, number> = {
  very_high: 4,
  high: 3,
  medium: 2,
  low: 1,
};

export function isNoticePriority(value: string): value is NoticePriority {
  return (NOTICE_PRIORITIES as readonly string[]).includes(value);
}

export function canSetVeryHighPriority(
  membershipRole: string | undefined | null,
  isPlatformAdmin: boolean
): boolean {
  if (isPlatformAdmin) return true;
  return membershipRole === 'ADMIN' || membershipRole === 'MANAGER';
}

export function getPriorityColorClass(priority: string): string {
  switch (priority) {
    case 'very_high':
      return 'bg-red-200 text-red-900 border-red-400';
    case 'high':
      return 'bg-orange-100 text-orange-800 border-orange-300';
    case 'medium':
      return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    case 'low':
      return 'bg-green-100 text-green-800 border-green-300';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300';
  }
}
